import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "resources"
    }}>{`Resources`}</h1>
    <p>{`The following document provides a list of resources for you to better understand how to use Mobile SDK.`}</p>
    <h2 {...{
      "id": "aligning-major-sdk-versions"
    }}>{`Aligning major SDK versions`}</h2>
    <p>{`Learn how the Adobe Experience Platform Mobile SDKs are going to `}<a parentName="p" {...{
        "href": "major-version-alignment.md"
      }}>{`align major version releases`}</a>{` moving forward, and find answers to the frequently asked questions around this topic.`}</p>
    <h2 {...{
      "id": "managing-gradle-dependencies"
    }}>{`Managing Gradle dependencies`}</h2>
    <p>{`To learn how to manage Gradle dependencies of Mobile SDKs, please read the guide on `}<a parentName="p" {...{
        "href": "manage-gradle-dependencies.md"
      }}>{`managing Gradle dependencies`}</a>{`.`}</p>
    <h2 {...{
      "id": "managing-spm-dependencies"
    }}>{`Managing SPM dependencies`}</h2>
    <p>{`To learn how to manage SPM dependencies of Mobile SDKs, please read the guide on `}<a parentName="p" {...{
        "href": "manage-spm-dependencies.md"
      }}>{`managing SPM dependencies`}</a>{`.`}</p>
    <h2 {...{
      "id": "privacy-and-gdpr"
    }}>{`Privacy and GDPR`}</h2>
    <p>{`To learn how to manage consent and privacy obligations with Mobile SDK, please read the guide on `}<a parentName="p" {...{
        "href": "privacy-and-gdpr.md"
      }}>{`privacy and GDPR`}</a>{`.`}</p>
    <h2 {...{
      "id": "ios-privacy-manifest-and-related-changes"
    }}>{`iOS Privacy Manifest and related changes`}</h2>
    <p>{`To learn how Apple's privacy related announcements made in WWDC of 2023 affect the Mobile SDK, please read the guide on `}<a parentName="p" {...{
        "href": "privacy-manifest.md"
      }}>{`iOS privacy manifest and related changes`}</a>{`.`}</p>
    <h2 {...{
      "id": "frequently-asked-questions"
    }}>{`Frequently asked questions`}</h2>
    <p>{`To find answers to the most frequently asked questions about Mobile SDK, please read the document on `}<a parentName="p" {...{
        "href": "faq.md"
      }}>{`frequently asked questions`}</a>{`.`}</p>
    <h2 {...{
      "id": "adobe-mobile-library-v4-end-of-support"
    }}>{`Adobe Mobile Library (v4) end-of-support`}</h2>
    <p>{`You can learn about upgrading from Adobe Mobile Library (v4) to the Experience Platform SDKs by following the instructions in the `}<a parentName="p" {...{
        "href": "./upgrade-platform-sdks/index.md"
      }}>{`upgrading to Experience Platform SDKs overview`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      